import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { environment } from '../../environments/environment';
import { AuthService } from '../services/auth.service';

const AUTH_LOGIN_PATH = '/v1/auth/login';

export const authInterceptor: HttpInterceptorFn = (request, next) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = authService.getToken();
  const isLoginRequest = request.url.endsWith(AUTH_LOGIN_PATH);
  const isApiRequest = request.url.startsWith(environment.apiBaseUrl);
  const authorizedRequest =
    token && isApiRequest && !isLoginRequest
      ? request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        })
      : request;

  return next(authorizedRequest).pipe(
    catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401 && !isLoginRequest) {
        authService.clearSession();

        if (!router.url.startsWith('/login')) {
          void router.navigate(['/login'], {
            queryParams: {
              returnUrl: router.url
            }
          });
        }
      }

      return throwError(() => error);
    })
  );
};
